import { Button, Input } from "@material-tailwind/react";
import axios from "axios";
import { useState } from "react";
import { Navigate, useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { User } from "../../types";
import {
  setTokenInLocalStorage,
  setUserInLocalStorage,
} from "../lib/local-storage";
import { openSocketConnection } from "../lib/socket";
import useUser from "../store/user";

export default function LoginPage() {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { user, setUser } = useUser();
  const navigate = useNavigate();

  const onLoginSuccess = async (user: User, token: string) => {
    setUserInLocalStorage(user);
    setTokenInLocalStorage(token);
    setUser(user);
    openSocketConnection(token);
    toast.success("Logged in successfully!");
    navigate("/active-orders");
  };

  const attemptLogin = async (e) => {
    e.preventDefault();

    if (userName.length === 0) {
      // setPopover({
      // 	error: true,
      // 	title: 'Validation Failed',
      // 	message: 'Please enter a username'
      // });
      console.log("the username is bad and you should feel bad");
      return;
    }

    if (password.length === 0) {
      // setPopover({
      // 	error: true,
      // 	title: 'Validation Failed',
      // 	message: 'Please enter a password'
      // });
      console.log("the password is bad and you should feel bad");
      return;
    }

    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_RELAY_API_HOST}/super-admin-login`,
        {
          userName,
          password,
        }
      );

      if (data.success) {
        const { token, user } = data;
        onLoginSuccess(user, token);
      } else {
        setError("Invalid login");
        setTimeout(() => setError(""), 2000);
      }
    } catch (err) {
      console.error(err);
      // setPopover({ error: true, title: 'Login Error', message: `Could not login.` });
    }
  };

  if (user) {
    return <Navigate to="/active-orders" />;
  }

  return (
    <div className="flex flex-col justify-center px-6 lg:px-8 mt-36">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
          Login
        </h2>
      </div>

      <div className="mt-5 sm:mx-auto sm:w-full sm:max-w-sm">
        <form onSubmit={attemptLogin} className="space-y-6">
          <div>
            <div className="mt-2">
              <Input
                label="Username"
                crossOrigin=""
                value={userName}
                required
                onChange={(e) => setUserName(e.target.value)}
              />
            </div>
          </div>

          <div>
            <div className="flex items-center justify-between"></div>
            <div className="mt-2">
              <Input
                label="Password"
                crossOrigin=""
                type="password"
                value={password}
                required
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <div>
            <Button
              type="submit"
              className="flex w-full justify-center rounded-md bg-blue-700 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-blue-800"
            >
              Sign in
            </Button>

            {error && (
              <p className="text-center text-sm text-red-500 mt-4">{error}</p>
            )}
          </div>
        </form>
        <div className="mt-6 text-center text-sm text-gray-500">
          <Link to={'/password-reset'}>
            Forgot password
          </Link>
        </div>
      </div>
    </div>
  );
}
